import { Flex, FlexCol } from 'components/primitives/flex';
import { Text } from 'components/primitives/typography';
import { useAtomValue } from 'jotai';
import styled from 'styled-components';
import { captainOptionsAtom } from '../filterStore';
import { Box } from '../../../../primitives/box';
import { mediaMMdMax } from '../../../../../helpers/breakpoints';
import AtomRadioButton from '../fields/AtomRadioButton';

export default function CaptainFilterContent() {
  const captainOptions = useAtomValue(captainOptionsAtom);

  return (
    <FlexCol gap="2em" data-testid="search-filter-package-type-box">
      <Text fSize="12px" lHeight="1.5">
        Select if you would like a captain to operate your boat or if you would like to operate it yourself.
      </Text>
      <ButtonWrapper gap="20px">
        {captainOptions.map(({ value, selected, label }) => (
          <AtomRadioButton key={value} selected={selected} label={label} />
        ))}
      </ButtonWrapper>
    </FlexCol>
  );
}

const ButtonWrapper = styled(Flex)`
  display: flex;
  & > ${Box} {
    flex-grow: 1;
  }
  ${mediaMMdMax} {
    gap: 15px;
  }
`;
